module.exports = __webpack_public_path__ + "img/support.e88eec7.webp";